import { useEffect, useState } from 'react';
import { fetchInstituteProfile, profileCacheKey, readCached } from '../utils/navDataCache';
import { useAuth } from '../context/AuthContext';
import { getDppCategoryConfig, resolveInstituteArchetype } from '../utils/categoryScoping';
export default function useDppConfig() {
  const { user } = useAuth();
  // Start from the last known profile so the practice menu does not pop in after load.
  const [profile, setProfile] = useState(() => readCached(profileCacheKey(user))?.data || null);
  const [loading, setLoading] = useState(() => !readCached(profileCacheKey(user)));
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = (force = false) => {
      fetchInstituteProfile(user, { force })
        .then((data) => { if (active) { setProfile(data); setError(false); } })
        .catch(() => { if (active) setError(true); })
        .finally(() => { if (active) setLoading(false); });
    };
    const onPracticeUpdated = () => refresh(true);
    refresh();
    window.addEventListener('institute-practice-updated', onPracticeUpdated);
    return () => { active = false; window.removeEventListener('institute-practice-updated', onPracticeUpdated); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, user?.institute_id]);
  const archetype = resolveInstituteArchetype(profile?.category || user?.institute_category, profile?.subcategory || user?.institute_subcategory);
  return { ...getDppCategoryConfig(archetype, profile?.dpp_enabled), loading, error };
}
